var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 4.5L16.399 18.515C16.3172 19.7425 16.2762 20.3563 16.0111 20.8217C15.7777 21.2314 15.4256 21.5607 15.0013 21.7664C14.5193 22 13.9041 22 12.6739 22H7.99273C6.76248 22 6.14736 22 5.66537 21.7664C5.24103 21.5607 4.88895 21.2314 4.65554 20.8217C4.39041 20.3563 4.3495 19.7425 4.26767 18.515L3.33333 4.5M1 4.5H19.6667M15 4.5L14.6843 3.55275C14.3783 2.63479 14.2252 2.17581 13.9415 1.83648C13.6909 1.53682 13.3691 1.30487 13.0056 1.16191C12.5939 1 12.1102 1 11.1425 1H9.52413C8.5565 1 8.0728 1 7.66109 1.16191C7.29757 1.30487 6.97576 1.53682 6.72517 1.83648C6.44139 2.17581 6.28841 2.63479 5.98241 3.55275L5.66667 4.5",
    stroke: "#DC3F3C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ab6bb847ef734dbfa29c9ea958f918d3.svg";
export { ForwardRef as ReactComponent };